




















































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';

import { mapGetters } from 'vuex';

import { ConfigurationFeaturesStatus, CrudList, DataTable, NoDataFound } from '../../components';

import { AlignEnum, DomainEnum } from '../../enums';

import { ConfigurationsFormMixin, CrudListMixin } from '../../mixins/';

import { DataTableColumn } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { APP_CONSTS } from '../../store/app/app.consts';

export default {
  name: 'browse-configurations-list',
  components: {
    ConfigurationFeaturesStatus,
    CrudList,
    DataTable,
    NoDataFound
  },
  mixins: [CrudListMixin],
  computed: {
    ...mapGetters(APP_CONSTS.moduleName, {
      featuresTree: APP_CONSTS.getters.featuresTree
    }),
    requestFilters: function () {
      return { attributeValue: this.$route.params[ROUTER_CONSTS.params.attribute.value] };
    },
    tableColumns: function (): DataTableColumn[] {
      const fieldsMessages = this.messages.fields;
      return [
        {
          id: 'name',
          text: fieldsMessages.name.label,
          sortable: true,
          width: '75%'
        },
        ...this.pivotsColumns,
        {
          id: 'modified',
          text: fieldsMessages.features.label,
          width: '13rem',
          align: AlignEnum.CENTER
        }, {
          id: 'inheritance',
          text: fieldsMessages.inheritance.label,
          width: '8rem',
          align: AlignEnum.CENTER
        }, {
          id: 'meta.updateDate',
          text: fieldsMessages.updateDate.label,
          sortable: true
        }, {
          id: 'meta.user',
          text: fieldsMessages.user.label,
          sortable: true
        }, {
          id: 'enabled',
          text: fieldsMessages.enabled.label,
          sortable: true
        }
      ];
    },
    toolsAvailability: function () {
      return ConfigurationsFormMixin.computed.toolsAvailability.bind(this)();
    }
  },
  data: function () {
    return {
      dataType: ActionTypeEnum.CONFIGURATION,
      routes: {
        create: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].create,
        update: ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].update
      },
      messages: this.$epb.messages.tools.configurations
    };
  },
  props: {
    loading: Object
  },
  methods: {
    getInheritanceLabel: function (inheritance: boolean): string {
      const inheritanceStatesMessages = this.messages.fields.inheritance.states;
      return inheritance ? inheritanceStatesMessages.enabled : inheritanceStatesMessages.disabled;
    }
  }
};
